module.exports = __webpack_public_path__ + "static/media/logo_black.18631af9.png";